// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ConfiguracoesSistema_ListWithFranquiaDataResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET
 * /config/configuracoes_sistema/list_with_franquia_data/{franquia_id}.
 *
 * dados is the list of system configs joined with the franchise's overrides
 * (Configuracoes_sistema_model::list_with_franquia_data — the same model
 * method behind /config/configuracoes_sistema_franquia/list_with_franquia_data),
 * so it shares ConfiguracoesSistemaFranquia_ConfiguracaoRow.
 */
import type { ConfiguracoesSistemaFranquia_ConfiguracaoRow } from './ConfiguracoesSistemaFranquia_ConfiguracaoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ConfiguracoesSistema_ListWithFranquiaDataResponseDados = ConfiguracoesSistemaFranquia_ConfiguracaoRow[];

export type ConfiguracoesSistema_ListWithFranquiaDataResponse = ApiResponse<ConfiguracoesSistema_ListWithFranquiaDataResponseDados>;

registerResponseContract('ConfiguracoesSistema_ListWithFranquiaDataResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      config_sistema_franquia_id: { type: 'number',  required: false },
      nome:                       { type: 'string',  required: true },
      titulo:                     { type: 'string',  required: false },
      descricao:                  { type: 'string',  required: false },
      valor_padrao:               { type: 'string',  required: false },
      valor:                      { type: 'string',  required: false },
    },
  },
})
